import { useEffect, useState, useCallback } from 'react';

import {
  euMilitar,
  medcof,
  newMeusucesso,
  newTravel,
  performanc,
  performancTriade,
  numberone,
  wiseup,
  wiseupLive,
  wsp,
  resolveEnem,
  conquer,
  conquerUnna,
  cid,
} from 'themes';

/**
 * Array usado para identificar o tema do upsell ofertado e usar as informações desse tema
 * Importante prezar pelos temas de upsell como sendo os primeiros do array
 */
export const allAvailableProductThemes = [
  performancTriade,

  wiseupLive,
  newTravel,
  newMeusucesso,
  euMilitar,
  performanc,
  wsp,
  wiseup,
  numberone,
  resolveEnem,
  conquer,
  medcof,

  cid,
];

const AVAILABLE_THEMES_TO_SEARCH_BY_DS_BRAND = [conquerUnna];

// const BUSINESS_AVAILABLE_TO_USE_NEW_PRODUCT_STRUCT = [
//   Business.VENDE_C,
//   Business.APROVATOTAL,
//   Business.ATRINCA,
//   Business.POWERHOUSE,
//   Business.MENTORING_LEAGUE_SOCIETY,
// ];

const BLACKLIST_BUSINESS_AVAILABLE_TO_USE_NEW_PRODUCT_STRUCT = [
  Business.WISEUP_ONLINE,
  Business.WISEUP_LIVE,
  Business.WISEUP,
  Business.MEUSUCESSO,
  Business.EUMILITAR,
  Business.PERFORMAN_C,
  Business.WISER,
  Business.MEDCOF,
  Business.CONQUER_FRANQUIAS,
  Business.CONQUER_BUSINESS_SCHOOL,
  Business.CONQUER_INCOMPANY,
  Business.CONQUER_EDTECH,
  Business.CONQUER,
  Business.CONQUER_UNNA,
  Business.INSTITUTO_DESTINY,
];

const getThemeProductsByAreaAndLang = ({
  product,
  area,
  productSlug,
  dsBrand,
}) => {
  const themesByProductAndArea = {
    WUP: {
      BR: newTravel,
    },
    MS: {
      BR: newMeusucesso,
    },
    EM: {
      BR: euMilitar,
    },

    PERFORMANC: {
      BR: performanc,
    },
    WSP: {
      BR: wsp,
    },
    LIVE: {
      BR: wiseupLive,
    },
    EXEC: {
      BR: wiseup,
    },
    NUMBERONE: {
      BR: numberone,
    },
    'N1-MD': {
      BR: numberone,
    },
    TEENS: {
      BR: wiseup,
    },
    SILVER: {
      BR: wiseup,
    },
    'SILVER-MD': {
      BR: wiseup,
    },
    MEDCOF: {
      BR: medcof,
    },
    RESOLVEENEM: {
      BR: resolveEnem,
    },
    ESCOLACONQUER: {
      BR: conquer,
    },
    CONQUERFRANQUIAS: {
      BR: conquer,
    },
    'CUNNA-EFLM': {
      BR: conquerUnna,
    },
    INSTITUTODESTINY: {
      BR: cid,
    },
    MERCURY: {
      BR: newMeusucesso,
    },
  };

  if (
    dsBrand &&
    AVAILABLE_THEMES_TO_SEARCH_BY_DS_BRAND.find(
      (item) => item.data.dsProductId === dsBrand
    )
  ) {
    return AVAILABLE_THEMES_TO_SEARCH_BY_DS_BRAND.find(
      (item) => item.data.dsProductId === dsBrand
    );
  }

  if (
    themesByProductAndArea[productSlug?.toUpperCase()] &&
    themesByProductAndArea[productSlug?.toUpperCase()][area]
  ) {
    return themesByProductAndArea[productSlug?.toUpperCase()][area];
  }

  if (themesByProductAndArea[product][area]) {
    return themesByProductAndArea[product][area];
  }

  if (themesByProductAndArea[product]?.BR) {
    return themesByProductAndArea[product].BR;
  }

  return newMeusucesso;
};

// ============================================================================
// NEW IMPLEMENTATION - Dynamic Theme Management System
// ============================================================================

// Import global defaults
import {
  spacing,
  font,
  lineHeight,
  border,
  opacity,
  shadow,
  breakpoints,
} from 'themes/global';
import { ProviderBrandAttribute } from '@wisereducacao-npm/design-system-brands-web/dist/components/provider/types';
import { Business } from 'types';

// Function to get design system brand from product

interface TokensType {
  // Existing color tokens
  ColorPrimaryDark: string;
  ColorPrimaryLight: string;
  ColorPrimaryMedium: string;
  ColorPrimaryPure: string;
  ColorSecondaryDark: string;
  ColorSecondaryLight: string;
  ColorSecondaryMedium: string;
  ColorSecondaryPure: string;
  NeutralColorButton: string;
  NeutralColorHighContrast: string;
  NeutralColorLowContrast: string;
  NeutralColorMediumContrast: string;
  NeutralColorPure: string;
  FeedbackColorSuccessHighContrast: string;
  FeedbackColorSuccessLowContrast: string;
  FeedbackColorSuccessMediumContrast: string;
  FeedbackColorSuccessPure: string;
  FeedbackColorAlertHighContrast: string;
  FeedbackColorAlertLowContrast: string;
  FeedbackColorAlertMediumContrast: string;
  FeedbackColorAlertPure: string;
  FeedbackColorErrorHighContrast: string;
  FeedbackColorErrorLowContrast: string;
  FeedbackColorErrorMediumContrast: string;
  FeedbackColorErrorPure: string;
  FeedbackColorButton: string;
  // Font tokens
  FontFamilyPrimary: string;
}

// Default theme colors to use as fallback
const defaultTheme = {
  color: {
    primary: {
      dark: '#1A1A1A',
      light: '#F5F5F5',
      medium: '#808080',
      pure: '#000000',
    },
    secondary: {
      dark: '#1A1A1A',
      light: '#F5F5F5',
      medium: '#808080',
      pure: '#000000',
    },
    neutral: {
      button: '#808080',
      highContrast: '#1A1A1A',
      lowContrast: '#F5F5F5',
      mediumContrast: '#808080',
      pure: '#000000',
    },
    feedback: {
      success: {
        highContrast: '#006400',
        lowContrast: '#90EE90',
        mediumContrast: '#32CD32',
        pure: '#008000',
      },
      alert: {
        highContrast: '#8B4513',
        lowContrast: '#FFE4B5',
        mediumContrast: '#DEB887',
        pure: '#CD853F',
      },
      error: {
        highContrast: '#8B0000',
        lowContrast: '#FFB6C1',
        mediumContrast: '#DC143C',
        pure: '#FF0000',
      },
      button: '#808080',
    },
  },
  // Add global defaults
  spacing,
  font: {
    ...font,
    family: {
      primary: 'Nunito, sans-serif', // Default fallback font
    },
  },
  lineHeight,
  border,
  opacity,
  shadow,
  breakpoints,
};

// Theme cache to avoid unnecessary regeneration
const themeCache = new Map<string, typeof defaultTheme>();

// Standard theme structure factory - including all theme properties
const createTheme = (tokens: TokensType) => {
  return {
    color: {
      primary: {
        dark: tokens.ColorPrimaryDark,
        light: tokens.ColorPrimaryLight,
        medium: tokens.ColorPrimaryMedium,
        pure: tokens.ColorPrimaryPure,
      },
      secondary: {
        dark: tokens.ColorSecondaryDark,
        light: tokens.ColorSecondaryLight,
        medium: tokens.ColorSecondaryMedium,
        pure: tokens.ColorSecondaryPure,
      },
      neutral: {
        button: tokens.NeutralColorButton,
        highContrast: tokens.NeutralColorHighContrast,
        lowContrast: tokens.NeutralColorLowContrast,
        mediumContrast: tokens.NeutralColorMediumContrast,
        pure: tokens.NeutralColorPure,
      },
      feedback: {
        success: {
          highContrast: tokens.FeedbackColorSuccessHighContrast,
          lowContrast: tokens.FeedbackColorSuccessLowContrast,
          mediumContrast: tokens.FeedbackColorSuccessMediumContrast,
          pure: tokens.FeedbackColorSuccessPure,
        },
        alert: {
          highContrast: tokens.FeedbackColorAlertHighContrast,
          lowContrast: tokens.FeedbackColorAlertLowContrast,
          mediumContrast: tokens.FeedbackColorAlertMediumContrast,
          pure: tokens.FeedbackColorAlertPure,
        },
        error: {
          highContrast: tokens.FeedbackColorErrorHighContrast,
          lowContrast: tokens.FeedbackColorErrorLowContrast,
          mediumContrast: tokens.FeedbackColorErrorMediumContrast,
          pure: tokens.FeedbackColorErrorPure,
        },
        button: tokens.FeedbackColorButton,
      },
    },
    // Add global defaults
    spacing,
    font: {
      ...font,
      family: {
        primary: tokens.FontFamilyPrimary || defaultTheme.font.family.primary,
      },
    },
    lineHeight,
    border,
    opacity,
    shadow,
    breakpoints,
  };
};

// Dynamic token loader
const loadTokens = async (brand: string, mode: string = 'dark') => {
  try {
    return await import(
      `@wisereducacao-npm/design-system-tokens/dist/esm/${brand}/${mode}/${mode}`
    );
  } catch (error) {
    console.error(`Failed to load tokens for ${brand}/${mode}:`, error);
    return null;
  }
};

export function useProductThemeNew({
  product = 'MS',
  dsBrand = 'ms',
  dsMode = 'dark',
  productSlug,
  business = Business.VENDE_C,
  area = 'BR',
}: {
  product?: string;
  dsMode?: 'dark' | 'light';
  dsBrand?: ProviderBrandAttribute;
  area?: string;
  productSlug?: string;
  business?: Business;
}) {
  const cacheKey = `${dsBrand}-${dsMode}`;

  const getTheme = useCallback(async () => {
    if (themeCache.has(cacheKey)) {
      return themeCache.get(cacheKey);
    }

    const tokens = await loadTokens(dsBrand, dsMode);
    if (!tokens) {
      return defaultTheme;
    }

    const theme = createTheme(tokens);
    themeCache.set(cacheKey, theme);
    return theme;
  }, [cacheKey, dsBrand, dsMode]);

  const [theme, setTheme] = useState(
    () => themeCache.get(cacheKey) || defaultTheme
  );

  useEffect(() => {
    getTheme().then(setTheme);
  }, [getTheme]);

  if (
    !BLACKLIST_BUSINESS_AVAILABLE_TO_USE_NEW_PRODUCT_STRUCT.includes(business)
  ) {
    return theme;
  }

  return getThemeProductsByAreaAndLang({
    product,
    area,
    productSlug,
    dsBrand,
  });
}
